import { graphql, useStaticQuery } from "gatsby";
import { useIntl } from "gatsby-plugin-intl";
import { GatsbyImage, getImage, ImageDataLike } from "gatsby-plugin-image";
import { BLOCKS } from "@contentful/rich-text-types";
import { Options } from "@contentful/rich-text-react-renderer";
import styled from "styled-components";

import { ModalType, useModal } from "../state/ModalProvider";
import { ContentfulDamAsset, ContentfulTextSection } from "../types/Contentful";

import { Modal } from "./Modal";
import { Body3, Heading5 } from "./Typography";
import RichText from "./RichTextV2";

const StyledList = styled.ul`
  padding-left: 1em;
  text-align: left;
  
  list-style: disc;
  margin-bottom: 2px;
  li{
    margin-bottom: 2px;
  }
`;

const StyledBody3 = styled(Body3)`
  margin-bottom: 2px;
  text-align: left;
`;

const ContentWrapper = styled.div`
  text-align: left;
  padding-left: 20px;
  margin-top: 24px;
`;

const options: Options = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => <StyledBody3>{children}</StyledBody3>,
    [BLOCKS.UL_LIST]: (_, children) => <StyledList>{children}</StyledList>,
  },
};

const PcoCardNumberInfoModal = () => {
  const { locale } = useIntl();
  const { en, fr } = useStaticQuery(query);
  const data = locale === 'fr' ? fr : en;
  const { closeModal } = useModal();
  const { modalContentSections, modalHeading } = data;

  return (
    <Modal
      type={ModalType.PCO_CARD_NUMBER_INFO}
      onClose={() => closeModal(ModalType.PCO_CARD_NUMBER_INFO)}
    >
      <Heading5>{modalHeading}</Heading5>
      {(modalContentSections).map((section: ContentfulTextSection & ContentfulDamAsset) => {
        switch (section?.internal?.type) {
          case "ContentfulTextSection":
            return (
              <ContentWrapper key={section.id}>
                <RichText document={section.bodyRTF} options={options} />
              </ContentWrapper>
            );
          case "ContentfulDamAsset": {
            const image = getImage(section.asset.localImage as ImageDataLike);
            return image ? (
              <GatsbyImage
                key={section.id}
                data-testid={`image-${section.id}`}
                image={image}
                alt={section.altText}
              />
            ) : null;
          }
          default:
            return null;
        }
      })}
    </Modal>
  );
};

const query = graphql`
  query {
    en: contentfulModal(
      modalType: { eq: "PCO_CARD_NUMBER_INFO" }
      node_locale: { eq: "en-CA" }
    ) {
      ...Modal  
    }
    fr: contentfulModal(
      modalType: { eq: "PCO_CARD_NUMBER_INFO" }
      node_locale: { eq: "fr-CA" }
    ) {
      ...Modal  
    }
  }
`;

export default PcoCardNumberInfoModal;
